import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { ErrorLogs } from '@/features/admin/error-logs'

const errorLogsSearchSchema = z.object({
  timeRange: z
    .enum(['15m', '30m', '1h', '6h', '24h'])
    .optional()
    .catch('1h'),
  statusType: z.enum(['all', '4xx', '5xx']).optional().catch('all'),
  functionFilter: z.string().optional(),
  refreshInterval: z.enum(['off', '30s', '1m', '5m']).optional().catch('off'),
})

export type ErrorLogsSearchParams = z.infer<typeof errorLogsSearchSchema>

export const Route = createFileRoute('/_authenticated/admin/error-logs')({
  validateSearch: errorLogsSearchSchema,
  component: ErrorLogs,
})
